import { createApp } from 'vue'
import App from './App.vue'
import router from './router';

import { IonicVue } from '@ionic/vue';
import { createPinia } from 'pinia'
import { useAppStore } from '@/store/modules/app'
import { initCache } from '@/hooks/web/useCache'

/* Core CSS required for Ionic components to work properly */
import '@ionic/vue/css/core.css';

/* Basic CSS for apps built with Ionic */
import '@ionic/vue/css/normalize.css';
import '@ionic/vue/css/structure.css';
import '@ionic/vue/css/typography.css';

/* Optional CSS utils that can be commented out */
import '@ionic/vue/css/padding.css';
import '@ionic/vue/css/float-elements.css';
import '@ionic/vue/css/text-alignment.css';
import '@ionic/vue/css/text-transformation.css';
import '@ionic/vue/css/flex-utils.css';
import '@ionic/vue/css/display.css';

/* Theme variables */
import './theme/variables.css';
import './theme/style.scss';
import 'swiper/scss';
import '@ionic/vue/css/ionic-swiper.css';

import Vue3EasyDataTable from 'vue3-easy-data-table';
import 'vue3-easy-data-table/dist/style.css';

import * as IonComponents from '@ionic/vue';

const app = createApp(App)
  .use(IonicVue)
  .use(router)
  .use(createPinia());

Object.keys(IonComponents).forEach(key => {
  if (/^Ion[A-Z]\w+$/.test(key)) {
    app.component(key, IonComponents[key]);
  }
});

app.component('EasyDataTable', Vue3EasyDataTable);

// 初始化應用程式
async function initApp() {
  // 1. 先初始化 Ionic Storage
  await initCache()

  // 2. 初始化 store（從 Storage 讀取資料）
  const appStore = useAppStore()
  await appStore.initializeStore()

  // 3. 等待 router 就緒後再 mount（符合 Ionic Vue 官方建議）
  await router.isReady()
  app.mount('#app')
}

initApp()
